import axiosInstance from './AxiosInstance';
import { store } from '../store/store';

export function getCuisines() {
    return axiosInstance.get(`user/cuisines`);
}

export function createCuisine(category) {
    console.log(category);
    const state = store.getState();
    category.created_by = state.auth.auth.user.id;
    // const formData = new FormData();
    // formData.append("name", category.name);
    // formData.append("image", category.image);
    // formData.append("status", category.name);
    // formData.append("created_by", state.auth.auth.user.id);
    const postData = {
        ...category
    };
    return axiosInstance.post("admin/cuisines", postData,);
}
export function updateCuisine(category,id) {
    console.log(category);
    const state = store.getState();
    category.created_by = state.auth.auth.user.id;
    // const formData = new FormData();
    // formData.append("name", category.name);
    // formData.append("image", category.image);
    // formData.append("status", category.name);
    // formData.append("created_by", state.auth.auth.user.id);
    const postData = {
        ...category
    };
    return axiosInstance.put("admin/cuisines?id="+id, postData,);
}

export function getSelectedCuisine(id) {
    return axiosInstance.get(`admin/cuisines/show?id=`+id);
}
export function changeStatusCuisine(cuisine,id) {
    console.log(cuisine);
    const state = store.getState();
    cuisine.created_by = state.auth.auth.user.id;
    // const formData = new FormData();
    // formData.append("name", cuisine.name);
    // formData.append("image", cuisine.image);
    // formData.append("status", cuisine.name);
    // formData.append("created_by", state.auth.auth.user.id);
    const postData = {
        ...cuisine
    };
    return axiosInstance.put("admin/cuisines/status?id="+id, postData,);
}
export function deleteCuisine(id) {
    return axiosInstance.delete(`admin/cuisines?id=`+id);
}